import { FileStack, ListChecks, MessageSquareText, ClipboardList, Target } from "lucide-react";
import { Reveal } from "./Reveal";

const cards = [
    {
        icon: FileStack,
        testId: "bento-card-simulazioni",
        title: "3 simulazioni complete",
        desc: "Tre prove realistiche da 40 quesiti ciascuna.",
    },
    {
        icon: ListChecks,
        testId: "bento-card-quesiti",
        title: "120 quesiti",
        desc: "Quesiti di conoscenza, logico-deduttivi e situazionali.",
    },
    {
        icon: MessageSquareText,
        testId: "bento-card-correzioni",
        title: "Correzioni commentate",
        desc: "Risposte esatte con spiegazioni chiare e riferimenti normativi.",
    },
    {
        icon: ClipboardList,
        testId: "bento-card-scheda-risposte",
        title: "Schede risposte",
        desc: "Schema pratico per simulare la prova e autovalutarti.",
    },
    {
        icon: Target,
        testId: "bento-card-piano-ripasso",
        title: "Piano di ripasso finale",
        desc: "Una guida per concentrarti sugli argomenti chiave.",
    },
];

export const Bento = () => (
    <section id="pacchetto" className="relative bg-white py-20 sm:py-28">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
            <Reveal className="text-center">
                <h2 className="font-display text-3xl font-extrabold tracking-tight text-navy-950 sm:text-4xl lg:text-5xl">
                    Cosa trovi nel pacchetto
                </h2>
                <p className="mx-auto mt-4 max-w-xl text-base text-slate-500">
                    Tutto il materiale che ti serve per esercitarti in modo mirato ed efficace.
                </p>
            </Reveal>

            <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
                {cards.map((c, i) => (
                    <Reveal key={c.testId} delay={i * 0.07}>
                        <div
                            data-testid={c.testId}
                            className="group h-full rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:border-gold/60 hover:shadow-[0_18px_44px_rgba(10,30,60,0.1)]"
                        >
                            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-xl bg-navy-950 transition-colors duration-500 group-hover:bg-gold">
                                <c.icon className="h-7 w-7 text-gold transition-colors duration-500 group-hover:text-navy-950" />
                            </div>
                            <h3 className="mt-5 font-display text-base font-extrabold text-navy-950">{c.title}</h3>
                            <p className="mt-2.5 text-xs leading-relaxed text-slate-500">{c.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
